import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/ticket/v3/cms/admin`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const ticket3AdminManagementApi = {
  getAdminUser: (request) => {
    const { params } = request
    return instance().get(`/user`, {
      params
    })
  },
  postAdminUser: (request) => {
    const { data } = request
    // {
    //     "page_id": "212669041930795",
    //     "adminid": "zwizticket_v3_03",
    //     "password": "@Ticket|V.3_1234",
    //     "role": "agent",
    //     "admingroupid": 830, // OPTIONAL
    //     "adminsubgroupid": 422 // OPTIONAL
    // }
    return instance().post(`/user`, data)
  },
  putAdminUser: (request) => {
    const { data } = request
    // {
    //     "page_id": "212669041930795",
    //     "adminid": "zwizticket_v3_02",
    //     "password": "@Ticket|V.3_1234",
    //     "role": "agent",
    //     "admingroupid": 832, // OPTIONAL
    //     "adminsubgroupid": 424 // OPTIONAL
    // }
    return instance().put(`/user`, data)
  },
  deleteAdminUser: (request) => {
    // {
    //     "page_id": "212669041930795",
    //     "adminid": "zwizticket_v3_03"
    // }
    const { data } = request
    return instance().delete(`/user`, {
      data
    })
  },
  getAdminGroup: (request) => {
    const { params } = request
    return instance().get(`/group`, {
      params
    })
  },
  postAdminGroup: (request) => {
    const { data } = request
    // {
    //     "page_id": "212669041930795",
    //     "groupname": "Test 101",
    //     "groupdescription": "test create group",
    //     "admin_ids": [
    //         "zwizfluke"
    //     ]
    // }
    return instance().post(`/group`, data)
  },
  putAdminGroup: (request) => {
    const { data } = request
    // {
    //     "id": 829,
    //     "page_id": "212669041930795",
    //     "groupname": "Test 1012",
    //     "groupdescription": "test create group2",
    //     "admin_ids": [
    //         "zwizfluke"
    //     ]
    // }
    return instance().put(`/group`, data)
  },
  deleteAdminGroup: (request) => {
    const { data } = request
    // {
    //     "id": 829,
    //     "page_id": "212669041930795"
    // }
    return instance().delete(`/group`, {
      data
    })
  },
  getAdminSubGroup: (request) => {
    const { params } = request
    return instance().get(`/sub-group`, {
      params
    })
  },
  postAdminSubGroup: (request) => {
    const { data } = request
    // {
    //     "page_id": "212669041930795",
    //     "admingroupid": 832,
    //     "subgroupname": "1234567890",
    //     "subgroupdescription": null
    // }
    return instance().post(`/sub-group`, data)
  },
  putAdminSubGroup: (request) => {
    const { data } = request
    // {
    //     "id": 424,
    //     "page_id": "212669041930795",
    //     "admingroupid": 832,
    //     "subgroupname": "1234567890",
    //     "subgroupdescription": "1234567890"
    // }
    return instance().put(`/sub-group`, data)
  },
  deleteAdminSubGroup: (request) => {
    const { data } = request
    // {
    //     "id": 423,
    //     "page_id": "212669041930795",
    //     "admingroupid": 831
    // }
    return instance().delete(`/sub-group`, {
      data
    })
  },
  putChangePassword: (request) => {
    const { data } = request
    return instance().put(`/user/change-password`, data)
  },
  getAdminWorkingHours: (request) => {
    const { params } = request
    return instance().get(`/working-hours`, {
      params
    })
  },
  putAdminWorkingHours: (request) => {
    // {
    //     "page_id": "212669041930795",
    //     "working_hours": [
    //         {
    //             "open_at": "09:00:00",
    //             "close_at": "18:59:59",
    //             "status": true,
    //             "day_of_week": 0
    //         },
    //         {
    //             "open_at": "09:00:00",
    //             "close_at": "18:59:59",
    //             "status": true,
    //             "day_of_week": 1
    //         },
    //         {
    //             "open_at": "09:00:00",
    //             "close_at": "18:59:59",
    //             "status": true,
    //             "day_of_week": 2
    //         },
    //         {
    //             "open_at": "09:00:00",
    //             "close_at": "18:59:59",
    //             "status": true,
    //             "day_of_week": 3
    //         },
    //         {
    //             "open_at": "09:00:00",
    //             "close_at": "18:59:59",
    //             "status": true,
    //             "day_of_week": 4
    //         },
    //         {
    //             "open_at": "09:00:00",
    //             "close_at": "18:59:59",
    //             "status": true,
    //             "day_of_week": 5
    //         },
    //         {
    //             "open_at": "09:00:00",
    //             "close_at": "18:59:59",
    //             "status": true,
    //             "day_of_week": 6
    //         }
    //     ]
    // }
    const { data } = request
    return instance().put(`/working-hours`, data)
  }
}

export default ticket3AdminManagementApi



// WEBPACK FOOTER //
// ./src/api/ticket3/admin-management.js